
// *************************** Import CSS *************************** //

import '@styles/main.scss';
import "./fs2024-feature.css";

// *************************************************** Insert Fall Sessions 2024 Feature **************************************************** //

class FS2024Feature extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `

<!-- *********************************** BEGIN: FALL 2024 SATURDAY SESSIONS *************************************** -->

  <div id="fs24-container" class="container px-0">

    <!-- ************** BEGIN: Title of Section ************** -->

    <div class="container">
  
      <div class="col-lg-12 text-center mb-4">

        <span class="col-3 col-md-2 col-lg-1 badge badge-purple text-white mt-4">
          <img src="assets/icons/white-brackets.png" height="30px" alt="html brackets">
        </span>

        <div class="row col-12 d-flex justify-content-center text-center mx-auto mt-2">

          <p class="fs24-title col-12 col-md-6 col-lg-5 serif-heading bold text-center text-md-end p-0 m-0 text-white">
              Fall 2024
          </p>

          <p class="fs24-title col-12 col-md-6 serif-heading bold text-center text-md-start p-0 ps-md-2 m-0 text-white">
              Saturday Sessions
          </p>

        </div>

        <p class="fs24-title-2 serif-heading bold mx-auto text-center mt-0 pt-0 pb-0 mb-2 text-white">
            Celebrating Confetti, Connecting, &#38; Compound Interest
        </p>

      </div>

    </div>

    <!-- ************** END: Title of Section ************** -->


    <!-- ************** BEGIN: Confetti Button ************** -->

    <div class="container-fluid confetti-button-container px-0">

      <div class="row col-12 col-lg-8 d-flex justify-content-center text-center mx-auto">

        <section class="confetti-button-section">
      
          <button id="confetti-button" class="btn bold" type="button">
            CLICK TO CELEBRATE <span class="button-emoji">&#127881;</span>
          </button>
      
        </section>

      </div>

    </div>

    <!-- *************** END: Confetti Button *************** -->


  <!-- ************* BEGIN: Fall 2024 Saturday Sessions Content *********** -->

  <div class="container my-5 text-white">
  
    <div class="col-12 col-lg-10 mx-auto">
    
    <!-- FEATURE ROW 1: JAVASCRIPT CODING & EXCITING FIRSTS -->

    <div class="row g-4 align-items-center mb-5">

      <div class="col-12 col-lg-6 order-2 order-lg-1">

        <p class="fs24-text leading-relaxed bold mb-3 text-start px-2">
          Nearly 50 students attended our Fall 2024 Saturday Sessions. Our beginner students used HTML & CSS coding languages to 
          <a class="text-gold serif-heading text-size-h3 bold text-decoration-none mx-1" href="/student-websites">build their own websites</a>
          from a blank screen. Our returning students continued evolving their 
          <a class="text-gold serif-heading text-size-h3 bold text-decoration-none mx-1" href="/student-websites">already-created websites</a> by learning how to code 
          and customize the JavaScript-enabled confetti seen by clicking the celebration button above.
        </p>

        <p class="fs24-text leading-relaxed bold m-0 text-start px-2">
          Our Fall 2024 Saturday Sessions also kicked off a couple of exciting Girls Code Savannah "firsts". After a few of our long-time students relocated out of state, we opened our Returning Students classes to include virtual students. We will continue to offer this option to Returning Students going forward. The joy of keeping our growing community connected (and the fun of silly moustaches) sealed the deal!
        </p>

      </div>
      
      <!-- Split-screen grid: stacks 1-column on mobile, shifts to 2-columns on tablets/desktops -->

      <div class="col-12 col-lg-6 order-1 order-lg-2">

        <div class="row g-3 text-center justify-content-center">

          <div class="col-12">
            <img class="img-fluid fs2024-photo-set-1 rounded-3 shadow" src="assets/fall-sessions-2024/fs2024-javascript-confetti.png" alt="photo of students coding">
          </div>
     
          <div class="col-12">
            <img class="img-fluid fs2024-photo-set-1 rounded-3 shadow" src="assets/fall-sessions-2024/fs2024-virtual-students.png" alt="photo of zoom call">
          </div>

        </div>

      </div>
      
    </div>

    <!-- FEATURE ROW 2: FINANCIAL LITERACY SPOTLIGHT -->

    <div class="row g-4 align-items-center mb-5">

      <div class="col-12 col-lg-6">

        <div class="row g-3 text-center justify-content-center">

          <div class="col-12">
            <img class="img-fluid fs2024-photo-set-2 rounded-3 shadow mb-2" src="assets/fall-sessions-2024/fs2024-financial-literacy.png" alt="financial literacy banner">
          </div>
         
          <div class="col-12">
            <img class="img-fluid fs2024-photo-set-2 rounded-3 shadow" src="assets/fall-sessions-2024/fs2024-federal-reserve.png" alt="photo of students coding">
          </div>
          
          <div class="col-12">
            <img class="img-fluid fs2024-photo-set-2 rounded-3 shadow" src="assets/fall-sessions-2024/fs2024-compound-interest.png" alt="photo of students coding">
          </div>

        </div>

      </div>

      <div class="col-12 col-lg-6">
        <p class="fs24-text leading-relaxed bold mb-3 text-start px-2">
          Fall 2024 Saturday Sessions marked the beginning of incorporating financial literacy into our overall curriculum. This has always been part of our Executive Director's vision for the program. As an applied economist, she simply loves teaching it. As a software developer, she feels it is very important to equip students with the knowledge of how to responsibly care for and grow the money that often accompanies a lucrative career in STEM fields.
        </p>
        <p class="fs24-text leading-relaxed bold m-0 text-start px-2">
          Along with continuing their coding education, over the 4 Fall Saturday Sessions students also learned about (1) the history of and meaningful graphic symbolism incorporated into the dollar bill, (2) the Federal Reserve System and the role it plays in storing and distributing money, (3) the history and creation of coins, and (4) the magic of compound interest. To say that our students were exponentially intrigued is an understatement. <span class="emoji">😉</span> And we're just getting started.
        </p>
      </div>

    </div>


    <!-- THANK YOU BLOCK -->

    <div class="thank-you-block p-4 rounded-4 mb-5 shadow-sm">

      <p class="text-size-body leading-relaxed m-0 text-start bold">
        Girls Code Savannah once again partnered with 
        <a class="text-gold serif-heading text-size-h3 bold text-decoration-none mx-1" href="https://liveoakpl.org" target="_blank">Live Oak Public Libraries</a>
        and held our FREE Fall "Saturday Sessions" at the Bull Street & SW Chatham Library locations. 
        The sessions took place from 11:00 AM ‐ 1:30 PM on four Saturdays throughout October & November.
        We are incredibly thankful to our generous sponsors and partners who helped to make our Fall 2024 Saturday Sessions a great success!
      </p>

    </div>

  </div>
</div>
<!-- ************* END: Fall 2024 Saturday Sessions Content *********** -->

<!-- *************** BEGIN: Fall 2024 Sponsors ************ -->

<div class="col-12 text-center mx-auto my-5">     

  <div class="container">

    <div class="d-flex justify-content-center mb-4">
      <p class="thank-you-text serif-heading bold mx-auto text-center m-2 text-white">
        Thank You to Our Fall 2024 Sponsors & Partners!
      </p>
    </div>

    <!-- BEGIN: Sponsor Logo Section -->
    <div class="row g-3 justify-content-center align-items-center text-center">

      <!-- 1. Savannah Professional Women for Good -->
      <div class="col-12 col-tablet-6 col-lg-4">
        <a href="https://grapevine.org" target="_blank" class="cta-block d-flex align-items-center justify-content-center p-3 rounded-3">
          <img class="spwfg-img img-fluid sponsor-logo-img" src="assets/sponsor-logos/spwfg-logo.png" alt="Savannah Professional Women For Good logo">
        </a>
      </div>

      <!-- 2. Live Oak Libraries -->
      <div class="col-12 col-tablet-6 col-lg-4">
        <a href="https://liveoakpl.org" target="_blank" class="cta-block d-flex align-items-center justify-content-center p-3 rounded-3">
          <img class="fs24-live-oak-img img-fluid" src="assets/sponsor-logos/LOPL/lopl-full-round-logo-2026.png" alt="live oak libraries logo">
        </a>
      </div>

    </div>
    <!-- END: Sponsor Logo Section -->

  </div>
</div>
<!-- *************** END: Fall 2024 Sponsors ************ -->

</div>

<!-- *********************************** END: FALL 2024 SATURDAY SESSIONS ***************************************** -->

    `
  }
}


// *********************** Define 'extends HTMLElements' Above *********************** //

customElements.define('fs2024-feature', FS2024Feature);


// ************************* Confetti ************************* //

var confettiButton = document.getElementById('confetti-button');

const jsConfetti = new JSConfetti();

confettiButton.addEventListener('click', () => {
  jsConfetti.addConfetti({
    confettiColors: ['#B650B2', '#5E46BF', '#39AFB9', '#F4BF4C', '#72B4DF', '#97517B'],
  })
})

let star = String.fromCodePoint(0X1F31F);
let moneybag = String.fromCodePoint(0X1F4B0);
let computer = String.fromCodePoint(0X1F4BB);
let dollarbill = String.fromCodePoint(0X1F4B5);
let face = String.fromCodePoint(0X1F978);
let partyhat = String.fromCodePoint(0X1F389);

confettiButton.addEventListener('click', () => {
  jsConfetti.addConfetti({
      emojis: [computer , moneybag, dollarbill, star, face, partyhat],
  })
})

    
  